import React, {useEffect, useState, useRef} from 'react'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'
export default function KCASpotRateForm() {
    //all the states
    const [date, setDate] = useState('2023-08-09')
    const [exGinningPrices, setExGinningPrices] = useState()
    const [exSpotRatesKarachi, setExSpotRatesKarachi] = useState(235)
    const [clbs, setClbs] = useState()
    const [rateAvl, setRateAvl] = useState(false)
    const [dollarRate, setDollarRate] = useState()
    const [x, setX] = useState('')

    //references
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setDate(today);
        gerrit()
      }, []);

    //ex-ginning prices value
    const handlerEGP = (e) =>{
        setExGinningPrices(e.target.value)
    }
    useEffect(()=>{
       // console.log(exGinningPrices)
        setExSpotRatesKarachi(parseFloat(235) + parseFloat(exGinningPrices))
    },[exGinningPrices])

    //ex-spot rates karachi
    const handlerESRK = (e) =>{
        setExSpotRatesKarachi(e.target.value)
    }
    useEffect(()=>{
       // console.log("This is the ex spot rate", exSpotRatesKarachi, "this is the x value", x)
        const w = exSpotRatesKarachi
        setClbs(w/x)
    },[exSpotRatesKarachi])

    useEffect(()=>{
     // console.log(clbs)
    },[clbs])

    //clbs
    const handleClbs = (e) =>{
        setClbs(e.target.value)
    }
    useEffect(()=>{
       // console.log(clbs)
    },[clbs])

    //Date effect
    useEffect(()=>{
       // console.log(date)
    },[date])

    //fetching the USD rate 
  const gerrit =async ()=>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/usd-rate-ch`,{
      headers: {
        'x-access-token': token
      }
    })
    if(!response.ok){
      setRateAvl(false)
     // console.log("There is no rate")
    }
    else{
      const data = await response.json()
      setDollarRate(data.buying)
     // console.log("This is is the buyring rate", data.buying)
    }
  }

  //setting x which will be divided by the EKSR
  useEffect(()=>{
    setX((dollarRate*82.28456)/100)
   // console.log("This is the dollar rate", dollarRate)
  }, [dollarRate])

  //console
  useEffect(()=>{
   // console.log("This is the clbs", clbs)
  },[clbs])

  const reset = () =>{
    ref2.current.value=''
    ref3.current.value=''
    ref4.current.value-=''
    setExGinningPrices(null)
    setExSpotRatesKarachi(null)
    setClbs(null)
  }
  const handleSubmit =  async (e) =>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
    const items = {date:date, exGinningPrices:exGinningPrices, exSpotRatesKarachi:exSpotRatesKarachi, clbs:clbs}
    const response = await fetch(`${process.env.REACT_APP_API_URL}/create-kcaSR`,{
        method:"POST",
        headers:{
            "Content-Type":"application/json",
            'x-access-token':token
        },
        body:JSON.stringify(items)
    })
        // .then(console.log(items)).then(reset())
  }
  return (
    <>
    <div className="sidebar">
    <Sidebar/>
    </div>
    <div id='tabler'>
    <h1>KCA Spot Rate</h1>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
       
              <div className="mb-3">
        <label htmlFor="date" className="form-label">
          Date
        </label>
        <input
          type="date"
          className="form-control"
          min="0"
          required
          value={date || ""}
          onChange={(e) => {
            setDate(e.target.value)
           // console.log("Date changed")
          }}
        />
      </div>
          </div>
          <div className="col-md-6">
          <label for="exampleFormControlTextarea1" class="form-label">Ex-ginning</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" type="number"  onChange={handlerEGP} ref={ref2} required  />              </div>
          </div>
        </div>
           
<div className="row">
  <div className="col-md-6">
          
  <label for="exampleFormControlTextarea1" class="form-label" >Ex-Spot Rates Karachi</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" value={exSpotRatesKarachi} type="number" ref={ref3} readOnly placeholder="Readonly input here…" onChange={handlerESRK}/>              </div>
             
  </div>

  <div className="col-md-6">
          
  <label for="exampleFormControlTextarea1" class="form-label" >Clbs</label>
              <div class="input-group input-group-md mb-3">
              <input class="form-control" type="number" value={clbs} ref={ref4} readOnly placeholder="Readonly input here…" readonly/>  
  </div>
</div>

           
     
            </div>
              <button type="submit"className=" btn submit-btn">Submit</button>
      </form>
    </div>
    </>
    
  )
}
 